import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import StopsMetadata from './metadata/datamanager/StopsMetadata';
import CalendarMetadata from './metadata/datamanager/CalendarMetadata';
import DayTypesMetadata from './metadata/datamanager/DayTypesMetadata';
import LinesMetadata from './metadata/datamanager/LinesMetadata';
import MapPointsMetadata from './metadata/datamanager/MapPointsMetadata';
import PassingTimesMetadata from './metadata/datamanager/PassingTimesMetadata';
import PathStopsMetadata from './metadata/datamanager/PathStopsMetadata';
import SchedulesMetadata from './metadata/datamanager/SchedulesMetadata';
import SetOfDayTypesMetadata from './metadata/datamanager/SetOfDayTypesMetadata';
import LineColorMetadata from './metadata/datamanager/LineColorMetadata';
import BusSchedMetadata from './metadata/bussched/BusSchedMetadata';
import SchedListMetadata from './metadata/bussched/SchedListMetadata';
import LayoutConfigMetadata from './metadata/bussched/LayoutConfigMetadata';
import FontsMetadata from './metadata/bussched/FontsMetadata';
import UpdatesMetadata from './metadata/bussched/UpdatesMetadata';
import SpineMetadata from './metadata/bussched/SpineMetadata';

const componentMapping = {
    '/datamanager/stops': StopsMetadata,
    '/datamanager/calendar': CalendarMetadata,
    '/datamanager/dayTypes': DayTypesMetadata,
    '/datamanager/lines': LinesMetadata,
    '/datamanager/mapPoints': MapPointsMetadata,
    '/datamanager/passingTimes': PassingTimesMetadata,
    '/datamanager/pathStops': PathStopsMetadata,
    '/datamanager/schedules': SchedulesMetadata,
    '/datamanager/setOfDayTypes': SetOfDayTypesMetadata,
    '/datamanager/lineColors': LineColorMetadata,
    '/bussched': BusSchedMetadata,
    '/bussched/schedules/list': SchedListMetadata,
    '/bussched/layoutConfigurations': LayoutConfigMetadata,
    '/bussched/fontsResources': FontsMetadata,
    '/bussched/updates': UpdatesMetadata,
    '/bussched/spine': SpineMetadata,
    default: null,
};

export class Metadata extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {
                title: '',
            },
            loadedComponent: null,
        };
    }

    static propTypes = {
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired,
        item: PropTypes.string,
        label: PropTypes.string,
    };

    componentDidMount() {
        const { label, item } = this.props;
        
        this.setState({
            form: {
                title: label,
            },
            loadedComponent: this.loadComponent(item),
        });
    }

    loadComponent(item) {
        const component = componentMapping[item] || componentMapping.default;
        return component;
    }

    renderModal(loadedComponentElement) {
        const { show, onHide } = this.props;
        const { form } = this.state;

        return (
            <Modal show={show} onHide={onHide} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadedComponentElement}
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide}>Fechar</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        const { loadedComponent } = this.state;

        const loadedComponentElement = loadedComponent ? React.createElement(loadedComponent) : null;
        if(null === loadedComponentElement || undefined === loadedComponentElement) {
            return null;
        }

        return (
            <React.Fragment>
            <button className="btn-metadata larger-icon"
                onClick={this.toggleFormVisibility}>
                <span className="glyphicon glyphicon-question-sign"></span>
            </button>

            {this.renderModal(loadedComponentElement)}
            </React.Fragment>
        );
    }
}
